import React from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import EmersonHeader from "../components/header/EmersonHeader";
import FooterTwo from "../components/footer/FooterTwo";
import { useWhitepapers } from "../services/whitepaperService";

function WhitePapers() {
  const { data: whitepapersResponse, isLoading } = useWhitepapers();
  const whitepapers = whitepapersResponse?.data || [];

  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Resources", link: "#" },
    { label: "White Papers" },
  ];

  return (
    <div className="whitepaper-page">
      <EmersonHeader />
      <Breadcrumb title="White Papers" breadcrumbs={breadcrumbs} />

      <section
        className="whitepaper-hero rts-section-gap"
        style={{ paddingTop: "60px", paddingBottom: "60px" }}
      >
        <div className="container">
          <div
            style={{
              background: "linear-gradient(135deg, #0f1629 0%, #1a2332 100%)",
              padding: "50px 40px",
              borderRadius: "16px",
              color: "#ffffff",
              boxShadow: "0 20px 60px rgba(15, 22, 41, 0.3)",
              textAlign: "center",
            }}
          >
            <span
              style={{
                display: "inline-block",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontSize: "12px",
                fontWeight: "600",
                color: "rgba(255, 255, 255, 0.7)",
                marginBottom: "12px",
              }}
            >
              Knowledge Hub
            </span>
            <h1
              style={{
                fontSize: "36px",
                fontWeight: "700",
                marginBottom: "15px",
                color: "#fff",
                lineHeight: "1.3",
              }}
            >
              Published Research & Technical Papers
            </h1>
            <p
              style={{
                margin: "0 auto",
                maxWidth: "760px",
                fontSize: "16px",
                color: "rgba(255, 255, 255, 0.85)",
                lineHeight: "1.7",
              }}
            >
              Dive into our engineering insights across analyser systems,
              hydrogen, environmental compliance, and advanced manufacturing.
              Download the complete PDF to explore architectures, methodologies,
              and lessons from the field.
            </p>
          </div>
        </div>
      </section>

      <section
        className="whitepaper-grid"
        style={{ paddingTop: "40px", paddingBottom: "80px" }}
      >
        <div className="container">
          {isLoading ? (
            <div className="row g-4">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="col-12">
                  <div
                    style={{
                      background: "#f9f9f9",
                      borderRadius: "12px",
                      padding: "24px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  >
                    <div
                      style={{
                        background: "#e0e0e0",
                        height: "24px",
                        width: "60%",
                        borderRadius: "4px",
                      }}
                    />
                    <div
                      style={{
                        background: "#e0e0e0",
                        height: "20px",
                        width: "150px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                </div>
              ))}
              <style>{`
                                @keyframes pulse {
                                    0%, 100% { opacity: 1; }
                                    50% { opacity: 0.6; }
                                }
                            `}</style>
            </div>
          ) : whitepapers.length > 0 ? (
            <div className="row g-4">
              {whitepapers.map((paper, index) => {
                const pdfUrl = `${process.env.REACT_APP_API_URL}/assets/images/whitepaper/${paper.pdf}`;
                const formattedDate = new Date(
                  paper.created_at
                ).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                });

                return (
                  <div key={paper.id || index} className="col-12">
                    <div
                      className="whitepaper-grid-item-container"
                      style={{
                        background: "#f9f9f9",
                        borderRadius: "12px",
                        padding: "24px 28px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#f5f5f5";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#f9f9f9";
                      }}
                    >
                      <Link
                        to={pdfUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          flex: 1,
                          textDecoration: "none",
                          color: "#1F1F21",
                          minWidth: 0,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#e00a0a";
                          e.currentTarget.style.textDecoration = "none";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#1F1F21";
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                      >
                        <p
                          className="whitepaper-title"
                          style={{
                            fontSize: "20px",
                            fontWeight: "700",
                            lineHeight: "1.5",
                            margin: 0,
                            textDecoration: "underline",
                            transition: "color 0.3s ease",
                            wordBreak: "break-word",
                          }}
                        >
                          {paper.name}
                        </p>
                      </Link>
                      <time
                        style={{
                          fontSize: "14px",
                          color: "#fff",
                          fontWeight: "400",
                          background: "#e00a0a",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          gap: "10px",
                        }}
                      >
                        <i className="fas fa-calendar-alt"></i>
                        {formattedDate}
                      </time>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  color: "#666",
                  margin: 0,
                }}
              >
                No whitepapers available at the moment.
              </p>
            </div>
          )}
        </div>
      </section>

      <FooterTwo />
      <style>{`
                @media (max-width: 991px) {
                    .whitepaper-hero h1 {
                        font-size: 28px !important;
                    }
                    .whitepaper-hero > div > div {
                        padding: 40px 30px !important;
                    }
                }
                @media (max-width: 767px) {
                    .whitepaper-hero h1 {
                        font-size: 24px !important;
                    }
                    .whitepaper-hero > div > div {
                        padding: 30px 20px !important;
                    }
                    .whitepaper-hero p {
                        font-size: 14px !important;
                    }
                    .whitepaper-grid {
                        padding-top: 30px !important;
                        padding-bottom: 60px !important;
                    }
                    .whitepaper-grid-item-container {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                        gap: 16px !important;
                    }
                    .whitepaper-title {
                        font-size: 18px !important;
                        text-align: left !important;
                    }
                    .whitepaper-grid-item-container time {
                        width: 100% !important;
                        text-align: center !important;
                    }
                }
                @media (max-width: 480px) {
                    .whitepaper-title {
                        font-size: 16px !important;
                    }
                    .whitepaper-grid-item-container {
                        padding: 20px !important;
                    }
                    .whitepaper-grid-item-container time {
                        font-size: 12px !important;
                        padding: 6px 12px !important;
                    }
                }
            `}</style>
    </div>
  );
}

export default WhitePapers;
